<template>
  <div v-if="value" class="array-field__item array-field__url">
    <img
      v-if="faviconUrl"
      class="array-field__url-favicon"
      :src="faviconUrl"
      alt=""
      loading="lazy"
      referrerpolicy="no-referrer"
      @error="faviconError = true"
    />
    <div class="array-field__ellipsis" :title="value">
      <a
        v-if="selected"
        :href="getHref(value)"
        target="_blank"
        rel="nofollow noopener noreferrer"
        class="forced-pointer-events-auto"
        @mousedown.stop
        >{{ value }}</a
      >
      <u v-else>{{ value }}</u>
    </div>
  </div>
</template>

<script>
import linkURLField from '@baserow/modules/database/mixins/linkURLField'
import { getFaviconUrl } from '@baserow/modules/core/utils/url'

export default {
  name: 'FunctionalFormulaURLArrayItem',
  mixins: [linkURLField],
  props: {
    value: {
      type: String,
      default: '',
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      faviconError: false,
    }
  },
  computed: {
    faviconUrl() {
      if (this.faviconError) return null
      // Fetch at 16px; it renders in a 14px slot so it stays crisp in the pill.
      return getFaviconUrl(this.value, 16)
    },
  },
  watch: {
    value() {
      this.faviconError = false
    },
  },
}
</script>
